module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_photowedding@3x-dce8106d54c5a9f2e9190ebad7728f25.webp";